module.exports = __webpack_public_path__ + "4d4dea159969ad35c1dc3c6c913f32ff.png";